export default __webpack_public_path__ + "static/media/pixel-moments-logo.88cfe5c9.svg";